import { IPG } from "@/types/summary";
import http from "./http";

export interface MeetingRecordParams {
  /**
   * 会议名称
   */
  name?: string;
  /**
   * 语言模型ID
   */
  languageModelId: string;
  /**
   * 功能id 3：语音转写 5：语音助手
   */
  future: number;
  thresholdScore?: number;
  useMarkDownSummary?: boolean;
  /**
   * 1. wav 2. mp3
   */
  audioFormat?: string;
}

export interface MeetingRecoderData {
  streamName: string;
  wssPushUrl: string;
  title: string;
}

export function startMeetingRecord(params: MeetingRecordParams) {
  return http.post<MeetingRecoderData>(
    "/api/auth/record-server/start-meeting-recording",
    params
  );
}

export function stopMeetingRecord(streamName: string) {
  return http.post("/api/auth/record-server/stop-meeting-recording", {
    streamName,
  });
}

export function renameMeetingTitle(streamName: string, title: string) {
  return http.post("/api/auth/live-record/rename", {
    streamName,
    title,
  });
}

interface ISaveDocParams {
  streamName: string;
  srcDoc: {
    pg: IPG[];
  };
}

export function saveDoc(params: ISaveDocParams) {
  return http.post("/api/auth/record-server/doc/save", {
    ...params,
  });
}
